import type { ComponentProps } from "react";
import { Menu } from "@/components/icons";
import { Button } from "@/components/ui/button";

export function MobileMenuButton(props: Omit<ComponentProps<typeof Button>, "variant" | "size" | "className">) {
  return (
    <Button {...props} variant="outline" size="icon" className="border-border xl:hidden">
      <Menu className="size-5 text-foreground" />
      <span className="sr-only">Open menu</span>
    </Button>
  );
}
